import {
  Typography, Backdrop
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import Paper from "@material-ui/core/Paper";
import ChangeIcon from 'src/components/ChangeIcon';
import axios from 'src/utils/axios';
import ExpandableComment from 'src/components/ExpandableComment';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0,
    minHeight: 430
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  divider: {
    backgroundColor: '#1D3343'
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main
  }
}));

function Tarihce({
  BasvuruId, OpenClose
}) {
  const classes = useStyles();
  const [yorumData, setYorumData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getApolloYorum(BasvuruId);
  }, [BasvuruId]);

  const getApolloYorum = (BasvuruId) => {
    setLoading(true)
    if (!BasvuruId) {
      return;
    }
    axios.get("/GetApolloYorum/" + BasvuruId + "/" + OpenClose, {
      responseType: 'arrayBuffer'
    }).then(response => {
      setYorumData(response.data)
      setLoading(false)
    });
  }

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Timeline align="alternate">
        {yorumData?.length > 0 && yorumData?.map((log, index) =>

          <TimelineItem >
            <TimelineOppositeContent>
              <Typography variant="body2" color="textSecondary"
                className={classes.inline}
              >
              </Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot color="inherit">
                <ChangeIcon MobilStatusId={log.DURUM_ID} />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Paper elevation={3} style={{ backgroundColor: '#e0e0e0', padding: "6px 16px" }} >
                <Typography variant="h6" component="h1"
                  className={classes.inline}
                  color="textPrimary"
                > <h2><b> {log.BASVURU_ID + ' - ' + log.DURUM} </b></h2>
                </Typography>
                <Typography>
                  <b> KULLANICI ADI SOYADI:</b> {log.ADSOYAD}
                  <br></br>
                  <b> YORUM:</b> <ExpandableComment Comment={log.YORUM} CommentLimit={500} DarkColor={false} />
                  <br></br>
                  <b> TARIH:</b> {log.GUN + " " + log.AY + " " + log.YIL + " " + "-" + " " + log.SAAT}
                </Typography>
              </Paper>
            </TimelineContent>

          </TimelineItem>
        )}
      </Timeline>
    </>




  );
}


Tarihce.propTypes = {
  className: PropTypes.string
};

export default connect(
  // state => ({
  //   taskHistoryReducer: state.taskHistoryReducer
  // }),
  // { taskHistoryRequest }
)(Tarihce);
